"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharingArtefact = void 0;
class SharingArtefact {
    constructor(data) {
        this.enableLikes = false;
        this.enableSharing = false;
        this.enableBookmarking = false;
        this.sharingLink = null;
        this.sharingMessage = null;
        this.isLiked = false;
        this.isBookmarked = false;
        if (data) {
            data = (typeof data === "string") ? JSON.parse(data) : data;
            this.enableLikes = (null === data.enableLikes) ? false : data.enableLikes;
            this.enableSharing = (null === data.enableSharing) ? false : data.enableSharing;
            this.enableBookmarking = (null === data.enableBookmarking) ? false : data.enableBookmarking;
            this.sharingLink = data.sharingLink;
            this.sharingMessage = data.sharingMessage;
            this.isLiked = data.hasOwnProperty('isLiked') ? data.isLiked : false;
            this.isBookmarked = data.hasOwnProperty('isBookmarked') ? data.isBookmarked : false;
        }
    }
}
exports.SharingArtefact = SharingArtefact;
//# sourceMappingURL=SharingArtefact.js.map